import React from "react"

import {
  TerminalAddButtonContainer,
  TerminalAddButtonCircle
} from "./TerminalAddButton.styled"

type Props = {
  onClick: () => void
  /** Horizontal offset in % from the node's left edge (e.g. "25%" for the
   *  condition's Then branch). */
  left?: string
  /** Highlight this "+" as an active drop target while a node is dragged over it. */
  highlighted?: boolean
}

const TerminalAddButton = ({
  onClick,
  left = "50%",
  highlighted = false
}: Props) => (
  <TerminalAddButtonContainer style={{ left }}>
    <TerminalAddButtonCircle
      type="button"
      aria-label="Add node"
      className="nodrag nopan"
      $highlighted={highlighted}
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      +
    </TerminalAddButtonCircle>
  </TerminalAddButtonContainer>
)

export default TerminalAddButton
